import React from "react";

// components

import TextInput from "../../../component/element/forms/TextInput";
import Modal from "../../../component/ui/modal/index";

// dispatch and state
import { useAppDispatch, useAppSelector } from "../../../store";
import { create_category } from "../../../services/apis/category";

type ICreateCategory = {
  show: boolean;
  onModal: () => void;
};

const CreateCategory: React.FC<ICreateCategory> = ({ show, onModal }) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ category }) => category.loading);

  const [data, dataSet] = React.useState<{ name: string }>({
    name: "",
  });

  const clear = () => {
    dataSet({ name: "" });
  };

  const handleOk = () => {
    create_category(dispatch, data.name);
  };

  return (
    <Modal
      open={show}
      title="New Category"
      isLoading={loading}
      onClose={() => {
        onModal();
        clear();
      }}
      onOkClick={() => handleOk()}
    >
      <TextInput
        label="Category Name"
        name="name"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          dataSet({ name: e.target.value })
        }
        placeholder="Enter Category Name"
        type="text"
        value={data.name}
      />
    </Modal>
  );
};

export default CreateCategory;
